import React, {useEffect, useState} from 'react';
import {Days} from "../../Store/days/days";

const Modal = ({day, setModal, setLastOpenedBox}) => {
    const [content] = useState(Days.filter(item => item.id === parseInt(day)))

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div
                className={'absolute flex justify-center items-center left-0 right-0 top-0 min-h-screen z-[150] bg-black/80 md:fixed'}>
                <div
                    className={"bg-white bg-modal bg-top bg-cover max-w-[950px] md:max-h-[95vh] md:mx-auto relative md:rounded-xl p-10 md:px-24 md:pb-6 md:pt-2 2xl:pt-6 md:overflow-y-auto rounded-lg m-5"}>
                    <button onClick={() => {
                        setModal({
                            dayId: null,
                            isVisible: false
                        })
                        setLastOpenedBox(day)
                    }}><img src="assets/X.png" alt="" className={'absolute right-5 top-5'}/>
                    </button>
                    {content[0].content}
                </div>
            </div>
        </>
    );
};

export default Modal;
